<template >
  <div style="padding-bottom: 70px">
    <div class="main-content" :style="{backgroundColor: `${tabledata.color}`}">
      <img @click.stop="loginNext(imgLink,tabledata.top_link)" :src="tabledata.top_image" alt="" class="spring-top-img">
      <div class="content" data-growing-container>
        <div v-for="model in tabledata.display_order" :key="model" class="block-common">
          <!-- 公司 -->
          <template v-if="model.includes('company_infos') && tabledata.company_infos && tabledata.company_infos.image">
            <div class="content-item" >
              <!-- <img :src="tabledata.company_infos.image" alt="" style="height: 456px" class="content-img" @click.stop="loginNext(imgLink,tabledata.company_infos.link)"> -->
              <!-- <div class="content-body">
                <div style="width: 990px; margin: 30px 0 30px 34px; overflow:hidden" ref="wrapper">
                  <div class="extrapolation-companys"  ref="contents">
                    <div class="companys select"  
                      :style="{width: tabledata.company_infos.company_detail_infos.length > 4 ? '164px' :'230px'} " 
                      v-for="(item,index) in tabledata.company_infos.company_detail_infos" :key="index"
                      @click.stop="loginNext(toCompanyDetail, item.token)"
                      @mouseover="showToast = true"
                      data-growing-container
                      :data-growing-idx="index + 20"  
                      >
                      <template >
                        <img :src="item.company_logo" alt="" @mousemove.prevent>
                        <p class="name overmore">{{item.company_name}}</p>
                        <p class="scale overmore">{{item.industry_name}}</p>
                        <p class="scale overmore">{{item.company_scale}}</p>
                      </template>
                      <div class="toast" v-if="tabledata.company_infos.tags && tabledata.company_infos.tags[index]">
                        <div class="toast-info overmore">
                          {{tabledata.company_infos.tags[index]}}
                        </div>
                        <div class="toast-btn">点击投递</div>
                      </div>  
                    </div>          
                  </div>   
                </div>                   
              </div> -->
              <div data-growing-container @click.stop="loginNext(imgLink,tabledata.company_infos.link)" class="company-carousel" :style="{backgroundImage:'url('+ tabledata.company_infos.image+ ')'}">
                  <div class="left" :style="{display: isMoreCompany ? 'block' : 'none', top: '243px'}" @click.stop="btnclickCompany('left')"><i class="iconfont iconzuo"></i></div>
                  <div class="right" :style="{display: isMoreCompany ? 'block' : 'none', top: '243px'}" @click.stop="btnclickCompany('right')"><i class="iconfont iconyou"></i></div>
                  <div :style="{width: isMoreCompany ? '1045px' : 'auto'}" style="overflow: hidden;height: 100%">
                    <el-carousel loop autoplay style="top: 131px;" :style="{left: isMoreCompany ? '89px' : '62px' }" ref="carouselCompany" arrow="never" indicator-position="none">
                      <el-carousel-item  data-growing-container style="display: flex" v-for="i in Math.ceil(tabledata.company_infos.company_detail_infos.length / 5)" :key="i + 'company'">
                        <template v-for="n in 5">
                        <div class="companys select"  
                          :style="{width: isMoreCompany ? '164px' : '175px'}" 
                          @click.stop="loginNext(toCompanyDetail, tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].token)"
                          @mouseover="showToast = true"
                          data-growing-container
                          :data-growing-idx="n + 20"
                          :key="n+'&companyItem'"
                          v-if="tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)]"
                          >
                          <template >
                            <img :src="tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].company_logo" alt="" @mousemove.prevent>
                            <p class="name overmore">{{tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].company_name}}</p>
                            <p class="scale overmore">{{tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].industry_name}}</p>
                            <p class="scale overmore">{{tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].company_scale}}</p>
                          </template>
                          <div class="toast" v-if="tabledata.company_infos.tags && tabledata.company_infos.tags[(i-1)*5 + (n-1)]">
                            <div class="toast-info overmore">
                              {{tabledata.company_infos.tags[(i-1)*5 + (n-1)]}}
                            </div>
                            <div class="toast-btn">点击投递</div>
                          </div>  
                        </div>  
                        </template>
                       
                      </el-carousel-item>
                      <!-- 防止两页的时候反复滚动   -->
                      <template v-if="isMoreCompany">
                        <el-carousel-item  data-growing-container style="display: flex" v-for="i in Math.ceil(tabledata.company_infos.company_detail_infos.length / 5)" :key="i + 'company'">
                        <template v-for="n in 5">
                        <div class="companys select"  
                          :style="{width: isMoreCompany ? '164px' : '175px'}" 
                          @click.stop="loginNext(toCompanyDetail, tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].token)"
                          @mouseover="showToast = true"
                          data-growing-container
                          :data-growing-idx="n + 20"
                          :key="n+'&companyItem'"
                          v-if="tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)]"
                          >
                          <template >
                            <img :src="tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].company_logo" alt="" @mousemove.prevent>
                            <p class="name overmore">{{tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].company_name}}</p>
                            <p class="scale overmore">{{tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].industry_name}}</p>
                            <p class="scale overmore">{{tabledata.company_infos.company_detail_infos[(i-1)*5 + (n-1)].company_scale}}</p>
                          </template>
                          <div class="toast" v-if="tabledata.company_infos.tags && tabledata.company_infos.tags[(i-1)*5 + (n-1)]">
                            <div class="toast-info overmore">
                              {{tabledata.company_infos.tags[(i-1)*5 + (n-1)]}}
                            </div>
                            <div class="toast-btn">点击投递</div>
                          </div>  
                        </div>  
                        </template>
                       
                        </el-carousel-item>
                      </template>
                     
                    </el-carousel>  
                  </div>
              </div>   

            </div>
          </template>
          <!-- 名企推荐 -->
          <template v-if="model.includes('company_job_detail_infos') && tabledata.company_job_detail_infos && tabledata.company_job_detail_infos.image">
            <div class="content-item" >    
              <div data-growing-container @click.stop="loginNext(imgLink,tabledata.company_job_detail_infos.link)" class="newneitui" :style="{backgroundImage:'url('+ tabledata.company_job_detail_infos.image + ')'}">
                  <div class="left" :style="{display: isMore ? 'block' : 'none'}" @click.stop="btnclick('left')"><i class="iconfont iconzuo"></i></div>
                  <div class="right" :style="{display: isMore ? 'block' : 'none'}" @click.stop="btnclick('right')"><i class="iconfont iconyou"></i></div>
                  <div :style="{width: isMore ? '1045px' : 'auto'}" style="overflow: hidden;height: 100%">
                    <el-carousel style="top: 141px;" :style="{left: isMore ? '89px' : '62px' }" ref="carousel" loop autoplay arrow="never" indicator-position="none">
                      <el-carousel-item  data-growing-container style="display: flex" v-for="i in Math.ceil(tabledata.company_job_detail_infos.company_job_detail_infos.length / 3)" :key="i + 'ab'">
                        <template v-for="n in 3">
                           <div @click.stop="loginNext(imgLink,tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].link)"
                              class="newneitui-item" 
                              :key="n + 'abc'"
                              :style="{width: isMore ? '306px' : '320px', marginRight: isMore ? '11px' : '16px'}"
                              data-growing-container
                              :data-growing-idx="i + 50"
                              v-if="tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)] && tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info"
                              >
                              <div class="neitui-top">                                         
                                  <img :src="tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_logo" alt="">
                                  <div class="item-info">
                                      <p class="overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_name}}</p>
                                      <div class="bottom" style="width: 188px">
                                          <span class="tag overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_city}}</span>
                                          <span class="split"></span>
                                          <span class="tag overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.industry_name}}</span>
                                          <span class="split"></span>
                                          <span class="tag overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_scale}}</span>
                                      </div>
                                      <p :style="{width: isMore ? '173px' : '188px'}" class="overmore" v-if="tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_highlights">
                                          <!-- <img class="good" src="https://files.wondercv.com/campaign-jobs/good.png" alt=""> -->
                                          <span class="overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_highlights}}</span>
                                      </p>
                                  </div>
                              </div>
                      
                              <div @click.stop="loginNext(toJobsDetail, jobs.token)" 
                                  class="neitui-middle " 
                                  v-for="(jobs,index) in tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_jobs" 
                                  :key="jobs.token"
                                  data-growing-container
                                  :data-growing-idx="(i+1)*389 + index"  
                              >
                                  <p class="overmore">{{jobs.job_post}}</p>
                                  <p>{{jobs.display_salary}}</p>
                              </div>
                            
                              <div class="neitui-bottom">
                                  查看更多
                              </div>
                          </div>
                        </template>
                      </el-carousel-item>
                      <template v-if="isMore">
                        <el-carousel-item  data-growing-container style="display: flex" v-for="i in Math.ceil(tabledata.company_job_detail_infos.company_job_detail_infos.length / 3)" :key="i + 'ab'">
                          <template v-for="n in 3">
                            <div @click.stop="loginNext(imgLink,tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].link)"
                                class="newneitui-item" 
                                :key="n + 'abc'"
                                :style="{width: isMore ? '306px' : '320px', marginRight: isMore ? '11px' : '16px'}"
                                data-growing-container
                                :data-growing-idx="i + 50"
                                v-if="tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)] && tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info"
                                >
                                <div class="neitui-top">                                         
                                    <img :src="tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_logo" alt="">
                                    <div class="item-info">
                                        <p class="overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_name}}</p>
                                        <div class="bottom" style="width: 188px">
                                            <span class="tag overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_city}}</span>
                                            <span class="split"></span>
                                            <span class="tag overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.industry_name}}</span>
                                            <span class="split"></span>
                                            <span class="tag overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_info.company_scale}}</span>
                                        </div>
                                        <p :style="{width: isMore ? '173px' : '188px'}" class="overmore" v-if="tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_highlights">
                                            <!-- <img class="good" src="https://files.wondercv.com/campaign-jobs/good.png" alt=""> -->
                                            <span class="overmore">{{tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_highlights}}</span>
                                        </p>
                                    </div>
                                </div>
                        
                                <div @click.stop="loginNext(toJobsDetail, jobs.token)" 
                                    class="neitui-middle " 
                                    v-for="(jobs,index) in tabledata.company_job_detail_infos.company_job_detail_infos[(i-1)*3 + (n-1)].company_jobs" 
                                    :key="jobs.token"
                                    data-growing-container
                                    :data-growing-idx="(i+1)*389 + index"  
                                >
                                    <p class="overmore">{{jobs.job_post}}</p>
                                    <p>{{jobs.display_salary}}</p>
                                </div>
                              
                                <div class="neitui-bottom">
                                    查看更多
                                </div>
                            </div>
                          </template>
                        </el-carousel-item>
                      </template>
                 
                    </el-carousel>  
                  </div>
              </div>        
            </div>           
          </template>
          <!-- 校招 -->
          <template v-if="model.includes('comp_recruit_infos') && tabledata.comp_recruit_infos">
                <div class="content-item" v-for="(item,index) in findBlockData(model)" :key="index + 'f'" :data-growing-idx="index + 140" data-growing-container>
                    <img :src="item.image" alt="" style="height: 374px" class="content-img"  @click.stop="loginNext(imgLink,item.link)">
                    <div class="content-body">
                        <div class="school" >
                          <template v-for="(school,sindex) in item.comp_recruit_detail">
                            <div v-if="Object.keys(school).length > 0" style="cursor: pointer" @click.stop="loginNext(imgLink,school.comp_recruit_info.url)"  class="school-item overmore" 
                            :key="sindex + 'g'" data-growing-container :data-growing-idx="index*499 + sindex + 100" >
                                <img :src="school.company_logo" alt="">
                                <div class="school-info" style="margin-left: 14px; ">
                                    <p class="overmore">{{school.comp_recruit_info.comp_name}}</p>
                                    <p class="overmore">{{school.category}}</p>
                                    <span style="max-width: 280px" class="overmore">{{ recruitmentTime(school.comp_recruit_res)}}</span>
                                </div>
                                <div class="toast" v-if="item.tags && !!item.tags[sindex]">
                                  <div class="toast-info overmore">
                                    {{item.tags[sindex]}}
                                  </div>
                                  <div class="toast-btn">点击投递</div>
                                </div> 
                            </div>
                          </template>
                        </div>
                    </div>
                </div>
          </template>
          <!-- 职位 -->
          <template v-if="model.includes('job_infos') && tabledata.job_infos">
              <div class="content-item" v-for="(item,index) in findBlockData(model)" :key="index + 'i'"  data-growing-container :data-growing-idx="index + 120">
                    <img :src="item.image" alt="" style="height: 396px" class="content-img"  @click.stop="loginNext(imgLink,item.link)">
                    <div class="content-body" >
                      <template v-for="(job, sindex) in item.job_detail_infos">
                        <div class="job-body" v-if="Object.keys(job).length > 0"  :key="sindex + 'j'" data-growing-container :data-growing-idx="index*599 + sindex + 150"
                            @click.stop="loginNext(toJobsDetail, job.token)" >
                            <div class="top">
                                <span class="overmore">{{job.job_post}}</span>
                                <span class="overmore">{{job.display_salary}}</span>
                            </div>
                            <div class="middle">
                                <span>{{job.city_names[0]}}</span>
                                <span>{{job.display_experience}}</span>
                                <span v-if="job.degree_name">{{job.degree_name}}</span>
                            </div>
                            <div class="bottom">
                                <img  :src="job.company_logo" alt="">
                                <span class="tag overmore">{{job.company_nick_name}}</span>
                                <span class="split overmore"></span>
                                <span class="tag overmore">{{job.company_industry}}</span>
                                <span class="split overmore"></span>
                                <span class="tag overmore">{{job.company_scale}}</span>
                            </div>
                            <div class="toast" v-if="item.tags && !!item.tags[sindex]">
                              <div class="toast-info overmore">
                                {{item.tags[sindex]}}
                              </div>
                              <div class="toast-btn">点击投递</div>
                            </div> 
                        </div>
                      </template>
                    </div>
              </div>
          </template>
          <!-- 简历模板 -->
          <template v-if="model.includes('sample_cv_infos') && tabledata.sample_cv_infos">
              <div class="content-item" v-for="(item,index) in findBlockData(model)" :key="index + 'a'" data-growing-container :data-growing-idx="index + 180">
                <img :src="item.image" alt="" class="content-img" style="cursor: pointer; height:396px" @click.stop="loginNext(imgLink,item.link)">
                <div class="content-body" >
                  <div @click.stop="loginNext(resumeLink,resume.token)" class="resume" v-for="(resume,sindex) in item.sample_cv_detail_infos" data-growing-container  :data-growing-idx="index*699 + 210" :key="sindex + 'b'" >
                    <div style="display:flex">
                      <img class="divimg" :src="resume.image" />
                      <div style="margin-left: 24px; flex: 1;overflow: hidden">
                          <div class="top">
                              <span class="top-left overmore">
                                {{resume.name}}   
                              </span>
                              <img src="https://files.wondercv.com/campaign-jobs/hot.png" alt="">
                          </div>
                          <div class="middle">
                              {{resume.desc}}
                          </div>
                      </div>
                    </div>
                    <div class="resume-bottom">
                      <span class="reusme-usecount overmore">{{resume.people_count | format}}人使用</span>
                      <div class="resume-btn">
                        <span class="bottom-left">立即使用</span>
                        <span class="bottom-right">收藏模板</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </template>
          <!-- 自定义模块 -->
          <template v-if="model.includes('custom_infos') && tabledata.custom_infos">
            <div
              v-for="(item, index) in findBlockData(model)"
              :key="index"
              class="custom-block-container"
              @click.stop="loginNext(imgLink, item.link)"
            >
              <img :src="item.image" alt="">
            </div>
          </template>
          <!-- 吸底模块 -->
          <template v-if="model.includes('bottom_content') && tabledata.bottom_content">
            <div class="bottom-content-container">
              <img
                v-for="(item, index) in tabledata.bottom_content"
                :key="index"
                :src="item.image"
                @click.stop="loginNext(imgLink, item.link)"
              />
            </div>
          </template>
          <!-- 横向视频 -->
          <template v-if="model.includes('horizontal_videos') && tabledata.horizontal_videos">
            <div
              v-for="(item, index) in findBlockData(model)"
              :key="index"
              :style="{'background-image': `url(${item.image})`}"
              class="horization-video-container"
              @click.stop="loginNext(imgLink, item.link)"
            >
              <div
                v-for="(childItem, childIndex) in item.videoList"
                :key="childIndex"
                class="video-item-content"
              >
                <div class="video-content">
                  <VideoItem
                    :src="childItem.video"
                    :poster="childItem.poster"
                  ></VideoItem> 
                </div>
                <div class="question">{{childItem.question}}</div>
                <div class="name">{{childItem.name}}</div>
                <div class="desc">{{childItem.desc}}</div>
              </div>
            </div>
          </template>
          <!-- 纵向视频 -->
          <template v-if="model.includes('vertical_videos') && tabledata.vertical_videos">
            <div
              v-for="(item, index) in findBlockData('vertical_videos')"
              :key="index"
              :style="{'background-image': `url(${item.image})`}"
              class="vertical-video-container"
              @click.stop="loginNext(imgLink, item.link)"
            >
              <div class="left-info-content">
                <div
                  v-for="(childItem, childIndex) in item.videoList"
                  :key="childIndex"
                  class="left-info-item"
                  :class="{'active': verticalVideoIndex[model.match(/#(.*)/)[1] - 1] === childIndex}"
                  @click.stop="changeVerticalVideoIndex(childIndex, model.match(/#(.*)/)[1] - 1)"
                >
                  <div class="question">
                    <img class="icon" src="https://logo.wondercv.com/banners/YswUWmWMYVON6DG.png" alt="">
                    {{childItem.question}}
                  </div>
                  <div class="user-info">
                    <img class="avatar" :src="childItem.avatar" alt="" />
                    <div class="info">
                      <div class="name">{{childItem.name}}</div>
                      <div class="desc">{{childItem.desc}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="video-content">
                <VideoItem
                  :active-index="verticalVideoIndex[model.match(/#(.*)/)[1] - 1]"
                  :src="item.videoList[verticalVideoIndex[model.match(/#(.*)/)[1] - 1]].video"
                  :poster="item.videoList[verticalVideoIndex[model.match(/#(.*)/)[1] - 1]].poster"
                ></VideoItem> 
              </div> 
            </div>
          </template>
        </div>
      </div>
    </div>
    <img v-if="tabledata.activity_infos.image" data-growing-container :src="tabledata.activity_infos.image" alt="" class="gift" @click.stop="loginNext(imgLink,tabledata.activity_infos.link)">
    <pc-footer/>
    <springfooter/>
  </div>
</template>

<script>
import pcFooter from '../../components/base/pcFooter'
import Springfooter from './components/springfooter.vue'
import VideoItem from './components/videoItem.vue'
import {routerTo,recruitmentTime} from '@/assets/js/util';
import BScroll from "better-scroll"
import moment from 'moment';
import {mapState} from 'vuex'
import { toLogin } from '@/assets/js/jwt';
import api from '../../api'
import Template from '../../components/resume/template.vue';
// import {tabledata} from './springOffer'
export default {
  name:'springMoves',
  components:{
    pcFooter,
    Springfooter,
    Template,
    VideoItem
  },
  computed:{
      ...mapState('me', ['isLogin']),
      isMore(){
          return this.tabledata.company_job_detail_infos && this.tabledata.company_job_detail_infos.company_job_detail_infos.length > 3
      },
      isMoreCompany () {
        console.log(this.tabledata, 'sadasdasd')
        return this.tabledata.company_infos.company_detail_infos && this.tabledata.company_infos.company_detail_infos.length > 5
      }
  },
  filters:{
    format (num) {  
      var reg=/\d{1,3}(?=(\d{3})+$)/g;   
      return (num + '').replace(reg, '$&,');  
    }
  },
  beforeCreate(){

  },
  data(){
   return {
       scroll: null,
       showToast: false, // 显示遮罩 
       moment,
       that: this,
       tabledata: {
           company_infos: null,
           sample_cv_infos: [],
           job_infos: [],
           activity_infos:{
               image: '',
               link: ''
           },
           channel: '',
           color: '',
           token: '',
           top_image: '',

       },
       verticalVideoIndex: []
    }
  },
  mounted(){
    api.jobs.getProfessionDetail('0', {url_suffix: this.$route.params.url}).then((res)=>{
       if(res.code == 1000){
          this.tabledata = res.data

          if (res.data.vertical_videos?.length) {
            this.verticalVideoIndex = Array.from({ length: res.data.vertical_videos.length }).fill(0)
          }

          if(this.tabledata.display_order.includes('company_infos')){
            this.verScroll()
          }       
       }
    }) 
  },
  methods:{
    findBlockData(model) {
      const [name, index] = model.split('#');
      if (index && this.tabledata[name]?.length) {
        return [this.tabledata[name][index - 1]]
      } else {
        return this.tabledata[name]
      }
    },
    changeVerticalVideoIndex(index, verticalIndex) {
      console.log(index, verticalIndex, '11')
      this.$set(this.verticalVideoIndex, verticalIndex, index)
      // this.verticalVideoIndex[verticalIndex] = index
      // console.log(this.verticalVideoIndex, 'verticalVideo')
    },
    recruitmentTime,
     loginNext(callback, tabledata){
        if(this.isLogin){
           callback(tabledata)
        } else {
           toLogin({login:true})
         } 
     },
     toSchool(token){
         routerTo(`${process.env.HOST_ROOT}/comp_recruit_infos/${token}`,'_blank')
     },
     toCompanyDetail(token){
         routerTo(`${process.env.HOST_ROOT}/company/${token}.html`,'_blank')
     },
     resumeLink(token){
          routerTo(`${process.env.HOST_ROOT}/jianlimoban/${token}.html`,'_blank')
     },
     imgLink(link) {
          const EDITOR_URL = 'https://www.wondercv.editor'
          if(!link) return
          if (link === EDITOR_URL && this.tabledata.cv_token) {
            routerTo(`${location.origin}/cvs/${this.tabledata.cv_token}/editor`, '_blank')
          } else {
            routerTo(link,'_blank')
          }
     },
     toJobsDetail(token){
          routerTo(`${process.env.HOST_ROOT}/jobs/${token}.html`,'_blank')
     },
     verScroll () {
      this.$nextTick(() => {
        let length = this.tabledata.company_infos.company_detail_infos.length
        let size = length > 4 ? 184 : 252
        let width = size * length // 动态计算出滚动区域的大小
        let dom = this.$refs.contents[0]
        dom.style.width = width + 'px' // 修改滚动区域的宽度  
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.wrapper[0], {
            startX: 0,  
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: 'vertical'
          })
        } else {
          this.scroll.refresh() //如果dom结构发生改变调用该方法
        }
      })
     },
     // 点击按钮
     btnclick(val){
      if(val == 'left' && this.$refs.carousel[0] ){
        this.$refs.carousel[0].prev()
      } 
      if(val == 'right' && this.$refs.carousel[0] ) {
        this.$refs.carousel[0].next()
      }
     },
     // 点击按钮
     btnclickCompany (val) {
      if(val == 'left' && this.$refs.carouselCompany[0] ){
        this.$refs.carouselCompany[0].prev()
      } 
      if(val == 'right' && this.$refs.carouselCompany[0] ) {
        this.$refs.carouselCompany[0].next()
      }
     }
  }
}
</script>
<style >
 #udesk_btn{
    display: none !important;
}
</style>
<style scoped lang="scss">
@mixin font($color, $size, $weight){
    color: $color;
    font-size: $size;
    font-weight: $weight;
}
@mixin flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
}
@mixin btn-position{
    position: absolute;
    z-index: 10;
    top: 290px;
    cursor: pointer;
    color: #FFBAAC;
}
@mixin div-size($w,$h,$radius,$color){
    width: $w;
    height: $h;
    border-radius: $radius;
    background-color: $color;
}
.toast{
  @include div-size(100%,250px,12px,rgba(0,0,0,0.8));
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 12;
  display: none;
  padding: 20px 24px 24px 24px;
  .toast-info{
    height: 168px;
    width: 100%;
    margin: auto;
    color: #FFFFFF;
    line-height: 24px;
    white-space: normal;
    word-break: break-all;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 7;
    text-align: left;
    margin-bottom: 8px;
  }
  .toast-btn{
    margin: auto;
    @include div-size(90px,30px,15px,linear-gradient(180deg, #FED74D 0%, #FF9B00 100%));
    @include font(#fff, 14px, 500);
    line-height: 30px;
    text-align: center;
    background: linear-gradient(180deg, #FED74D 0%, #FF9B00 100%);
  }
}
.good{
    width: 18px;
    height: 18px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
}

.company-carousel{
  width: 1116px;
  height: 456px;
  background-size:100% 100%;
  margin: auto;
  position: relative;
  cursor: pointer;
}
.newneitui{
    width: 1116px;
    height: 575px;
    background-size:100% 100%;
    margin: auto;
    position: relative;
    cursor: pointer;
     .newneitui-item{
        @include div-size(352px,356px,12px,#fff);
        padding: 20px 16px 22px 16px;
        box-sizing: border-box;
        margin-right: 16px;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);
        }
        .neitui-top{
            display: flex;
            margin-bottom: 24px;
            height: 77px;
            &>img{
                width: 77px;
                height: 77px;
                object-fit: contain;
                border-radius: 6px;
                margin-right: 12px;
                border: 1px solid #ececec;
            }
            .item-info{
                height: 77px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                &>p:nth-child(1){
                    @include font(#404040, 20px, 500);
                    max-width: 185px;
                }
                &>p:nth-child(3){   
                    padding: 2px 8px;
                    padding-left: 0px;
                    background: rgba(255, 165, 0, 0.08);
                    border-radius: 4px;
                    width: 188px;
                    display: flex;
                    align-items: center;
                    &>span{
                      max-width: 170px;
                      padding: 2px 8px;
                    }
                    @include font(#ff9f00, 12px, 400)
                }
            }
        }
        .neitui-middle{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 16px;
            width: 100%;
            height: 44px;
            box-sizing: border-box;
            background-color: #f9f9f9;
            border-radius: 4px;
            margin-bottom: 10px;
            cursor: pointer;
            &>p:nth-child(1){
                @include font(#404040, 14px, 500);
                max-width: 65%;
            }
            &>p:nth-child(2){
                @include font(#ff6644, 16px, 500);
                max-width: 35%;
            }
            &:hover{
                background-color: #FFF6F4;
                color: #FF6644;
            }
        }
        .neitui-bottom{
            margin: auto;
            width: 140px;
            height: 36px;
            border-radius: 18px;
            margin-top: 20px;
            border-radius: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 36px;
            @include font(#fff, 14px, 500);
            background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
        }
    }
    
}
.select{
    user-select:none;
}
.iconfont{
    font-size: 40px
}
/deep/ .el-carousel__container{
    height: 356px;
    width: auto;
    overflow: hidden;
}
.left{
    @include btn-position();
    left: 40px;
    color:rgba(255, 255, 255, 0.4);
    &:hover{
        color:rgba(255, 255, 255, 0.8);
    }
}
.right{
    @include btn-position();
    color:rgba(255, 255, 255, 0.4);
    right: 40px;
      &:hover{
        color:rgba(255, 255, 255, 0.8);
    }
}
.school{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    .school-item{
        width: 343px;
        height: 106px;
        padding: 16px;
        display: flex;
        box-sizing: border-box;     
        background: #FFFFFF;
        border-radius: 12px;
        margin-bottom: 12px;
        position: relative;
        &:hover {
          box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);
          .toast{
            display: flex;
            padding: 20px;
            height: 100%;
            .toast-info{
              width: 261px;
              height: 100%;
              margin-right: 20px;
              -webkit-line-clamp: 3;
            }
          }
        }
        img{
            border: 1px solid #ececec;
            border-radius: 12px;
            width: 74px;
            height: 74px;  
            object-fit: contain;
        }
        .school-info{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
        }
        .school-info>p:nth-child(1){
            max-width: 280px;
            @include font(#404040, 16px, 500)
        }
        .school-info>p:nth-child(2){
            max-width: 280px;
            @include font(#9C9C9C, 14px, 400)
        }
        .school-info>span{
            padding:2px 8px;  
            line-height: 20px;    
            background: #FFF6F4;
            @include font(#ff6644, 14px, 400)
        }
    }
}
.resume{
    background-color: #fff;
    border-radius: 12px;
    padding: 24px;
    width: 514px;
    // display: flex;
    // justify-content: space-between;
    margin-bottom: 24px;
    cursor: pointer;
    box-sizing: border-box;
    height: 243px;
    &:hover {
      box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);
    }
    // flex-wrap: wrap;
    .resume-bottom{
      display: flex;
      height: 44px;
      margin-top: 18px;
      .reusme-usecount{
        @include font(#ff6644, 14px, 400);
        display: inline-block;
        margin-right: 50px;
        line-height: 44px;
      }
      .resume-btn{
        display: flex;
        @include font(#fff, 14px, 500);
        .bottom-left {
            margin-right: 16px;
            height: 44px;
            border-radius: 22px;
            width: 140px;
            background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
            @include flex-center;
            &:hover{
              opacity: 0.8;
            }
        }
        .bottom-right{
            height: 44px;
            border-radius: 22px;
            width: 140px;
            border: 1px solid #FF6644;
            background-color: #fff;
            color: #FF6644;
            @include flex-center;
            &:hover{
              background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
              color: #fff;
            }
        }
      }
    }
    .divimg{     
        border-radius: 4px; 
        border: 1px solid #F4F4F4;
        width: 95px;
        height: 135px;
        flex-shrink: 0;
    }
    .top{
        display: flex;
        // justify-content: space-between;
        align-items: center;
        margin-top: 16px;
        &>img{
          display: inline-block;
          width: 48px;
          height: 16px;
          object-fit: contain;
          margin-left: 10px;
        }
    }
    .top-left{
        @include font(#404040, 18px, 500);
        max-width: 70%;
        line-height: 25px;
    } 
    .top-right{
        @include font(#FF6644, 14px, 400);
        max-width: 25%;
    }
    .middle{
        // padding: 12px 16px;
        margin-top: 10px;
        // background-color: #F9F9F9;
        overflow: hidden;
        max-height: 60%;
        line-height: 20px;
        @include font(#9c9c9c, 14px, 400)
    }
}
.overmore{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.main-content{
    min-width: 1280px;
    margin: auto;
}
.spring-top-img{
    width: 100%;
    display: block;
}
.content{
    padding-top: 40px;
    padding-bottom: 25px;
    .content-item{
        box-sizing: border-box;
        position: relative;
        .extrapolation-companys{
            touch-action:none;
            white-space: nowrap;
            display: flex;
        }
        .companys{
            cursor: pointer;
            display: inline-block;
            margin-right: 29px;
            width: 180px;
            height: 250px;
            background: #FFFFFF;
            border-radius: 12px;
            box-sizing: border-box;
            padding: 22px 12px;
            text-align: center;
            position: relative;
            .name{    
                height: 33px;
                line-height: 33px;  
                color: #404040;     
                font-weight: 600;
                font-size: 24px;
                margin-top: 20px;
                margin-bottom: 6px;
            }
            .scale{
                color: #9C9C9C;   
                font-weight: 400;
                font-size: 16px;
                margin-bottom: 3px;
            }
            &:hover{
              & .toast{
                display: block;
              }
            }
            &>img{
                width: 101px;
                height: 101px;
                margin: auto;
                border-radius: 12px;      
                border: 1px solid #ECECEC;
                object-fit: contain;
            }
        }
    }
    .content-img{
        width: 1116px;
        // object-fit: contain;
        display: block;   
        margin: auto; 
        border-radius: 20px;
        cursor: pointer;
    }
    .content-body{
       position: absolute;
       top: 100px;
       left: 50%;
       margin-left: -526px;
       width: 1052px;
       overflow: hidden;
       display: flex;
       justify-content: space-between;
       flex-wrap: wrap;
    }

}
.job-body{
    display: inline-block;
    cursor: pointer;
    padding: 16px;
    width: 343px;
    height: 117px;
    box-sizing: border-box;
    margin-bottom: 12px;
    background-color: #fff;
    // box-shadow: 0px 4px 32px 0px #EE6245;
    position: relative;
    border-radius: 12px;
    &:hover {
      box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);
      .toast{
        display: flex;
        padding: 24px;
        height: 100%;
        .toast-info{
          width: 261px;
          height: 100%;
          margin-right: 20px;
          -webkit-line-clamp: 3;
        }
      }
    }
    .top{
        display: flex;
        justify-content: space-between;
        line-height: 22px;
        &>span:nth-child(1){
            font-size: 16px;
            color: #404040;
            font-weight: 500;
            max-width: 65%;
        }
        &>span:nth-child(2){
            font-size: 15px;
            color: #FF6644;
            font-weight: 600;
            max-width: 35%;
        }
    } 
    .middle{
        margin-top: 6px;
        margin-bottom: 8px;
        &>span{
            box-sizing: border-box;
            color: #606060;
            font-size: 12px;
            padding: 3px 8px;
            display: inline-block;
            height: 23px;
            line-height: 17px;
            margin-right: 6px;
            background-color:#F4F4F4;  
            opacity: 0.75;
            border-radius: 4px;
        }
      
    }
    
}
.bottom{
        height: 24px;
        display: flex;
        align-items: center;
        .tag{
            display: inline-block;
            color: #606060;
            font-weight: 400; 
            font-size: 14px;
            max-width: 33%;
        }
        &>img{
            width: 24px;
            height: 24px;
            margin-right: 6px;
            display: inline-block;
            border-radius: 2px;  
            border: 1px solid #ECECEC;
            object-fit: contain;
            box-sizing: border-box;
        }
        .split{
            margin: 0 6px;
            display: inline-block;
            width: 1px;
            height: 9px;
            border-right: 1px solid #CFCFCF;
        }
    }
.gift{
    width: 184px;
    // height: 184px;
    position: fixed;
    right: 3px;
    top: 50vh;
    cursor: pointer;
    z-index: 99;
}

.block-common {
  margin-top: 120px;
  &:first-child {
    margin-top: 0;
  }
}

.custom-block-container img {
  width: 1200px;
  object-fit: contain;
  margin: 0 auto;
  cursor: pointer;
}
.bottom-content-container {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 50px;
  overflow: hidden;
  z-index: 999;
  cursor: pointer;
  img {
    width: 100vw;
  }
}
.horization-video-container {
  display: flex;
  align-items: center;
  width: 1200px;
  height: 476px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  padding-top: 84px;
  box-sizing: border-box;
  .video-item-content {
    width: 384px;
    height: 392px;
    padding: 20px 20px 36px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 24px;
    box-sizing: border-box;
    &:not(:last-child) {
      margin-right: 24px;
    }
    .video-content {
      position: relative;
      width: 344px;
      height: 200px;
      border-radius: 12px;
      margin-bottom: 24px;
    }
    .question {
      font-size: 20px;
      font-weight: 600;
      color: #1D2129;
      margin-bottom: 12px;
      line-height: 28px;
    }
    .name {
      color: #4E5969;
      margin-bottom: 12px;
      line-height: 16px;
    }
    .desc {
      color: #4E5969;
      line-height: 16px;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 这里是超出几行省略 */
      overflow: hidden;
    }
  }

}
.vertical-video-container {
  display: flex;
  align-items: center;
  width: 1200px;
  height: 864px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto;
  padding-top: 84px;
  box-sizing: border-box;
  .left-info-content {
    flex: 1;
    margin-right: 32px;
    padding: 56px 0;
    .left-info-item {
      width: 100%;
      height: 201px;
      background-color: #fff;
      border-radius: 24px;
      padding: 32px 32px 28px;
      box-sizing: border-box;
      border: 4px solid transparent;
      &:not(:last-child) {
        margin-bottom: 32px;
      }
      .question {
        display: flex;
        align-items: center;
        font-size: 20px;
        line-height: 24px;
        color: #FF6644;
        font-weight: 600;
        padding-bottom: 24px;
        border-bottom: 1px solid #E5E6EB;
        .icon {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
      }
      .user-info {
        display: flex;
        align-items: center;
        padding-top: 24px;
        .avatar {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          margin-right: 20px;
        }
        .info {
          .name {
            font-size: 20px;
            line-height: 24px;
            color: #1D2129;
            font-weight: 600;
            margin-bottom: 8px;
          }
          .desc {
            font-size: 14px;
            line-height: 16px;
            color: #4E5969;
          }
        }
      }
      &.active {
        border: 4px solid #ff6644;
      }
    }
  }
  .video-content {
    position: relative;
    width: 384px;
    height: 780px;
    border: 16px solid #000000;
    border-radius: 64px;
    overflow: hidden;
    background-color: #fff;
    box-sizing: border-box;
    ::v-deep(.play-icon) {
      width: 88px;
      height: 88px;
    }
  }
}
</style>